<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist @add="add" @search="search" @reflash="reflash" @exps="exp" @del="delall" @imp='imp'
                    ref="SetBtn"></buttonlist>
        <!-- 功能按钮 -->

        <!-- 表格 -->
        <el-table id="xpane-0" ref="multipleTable" :data="dataSet" v-loading="loading" :highlight-current-row="false"
                  show-overflow-tooltip="true" border stripe size="mini" header-row-class-name="headerclass"
                  :height="tableHeight" @cell-dblclick="cellDBClick"
                  tab-click="selectInfo(0)" @selection-change="handleSelectionChange"
                  style="width: 100%; margin-top:0px" @sort-change="sortChange"
                  :header-cell-style="$limits.headerClass">
            <el-table-column type="selection"></el-table-column>
            <el-table-column prop="order_no" :label="$t('getapi[2095]')" title="平台流水号" fixed
                             width="120" sortable="custom">
                <template slot-scope="scope">
                    <el-link style="padding-left: 3px;" :underline="false" type="primary" href="javascript:void(0)"
                             @click.native.prevent="dialog_show(scope)">{{scope.row.order_no}}
                    </el-link>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="order_status" :label="$t('getapi[1861]')" title="单据状态" fixed
                             sortable="custom"></el-table-column>
            <!-- <el-table-column show-overflow-tooltip prop="sort_id" :label="$t('getapi[889]')" title="流水号"></el-table-column> -->
            <el-table-column show-overflow-tooltip prop="csr_orderno" :label="$t('getapi[2693]')" title="客户订单号" fixed
                             width="120" sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop="csr_lineno" :label="$t('getapi[1586]')" title="订单行号"
                             align="right" sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop="csr_partcode" :label="$t('getapi[2390]')" title="客户零件号"
                             width="120" sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop="csr_qty" :label="$t('getapi[1829]')" title="订单数量" align="right"
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop="csr_id" :label="$t('getapi[2610]')" title="客户代码"
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop="csr_deliverydate" :label="$t('getapi[8131]')" title="客户交期" width="80"
                             sortable="custom" :formatter="myformatter"></el-table-column>
            <el-table-column show-overflow-tooltip prop="csr_orderdate" :label="$t('getapi[8132]')" title="订单日期" width="80"
                             sortable="custom" :formatter="myformatter">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="leadtime_total" :label="$t('getapi[8139]')" title="预估周期(天)" align="right"
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop="delivery_date" :label="$t('getapi[8136]')" title="估算日期" width="80"
                             sortable="custom" :formatter="myformatter"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_flag" :label="$t('getapi[8133]')" title="零件分类（简单/复杂）"
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop="leadtime_purchase" :label="$t('getapi[1520]')" title="采购周期(天)" align="right"
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop="leadtime_mold" :label="$t('getapi[8212]')" title="工装模具周期(天)" align="right"
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop="leadtime_produce" :label="$t('getapi[8137]')" title="制造周期(天)" align="right"
                             sortable="custom"></el-table-column>
            <!-- <el-table-column show-overflow-tooltip prop="sales_flag" :label="$t('getapi[450]')" title="销售价表" sortable="custom"></el-table-column> -->
            <!-- <el-table-column show-overflow-tooltip prop="csr_name" :label="$t('getapi[2584]')" title="客户名称"></el-table-column> -->
            <el-table-column show-overflow-tooltip prop="pm_name" :label="$t('getapi[6410]')" title="项目经理"
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pe_name" :label="$t('getapi[8142]')" title="项目工程师"
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pp_name" :label="$t('getapi[163]')" title="计划员"
                             sortable="custom"></el-table-column>
            <!-- <el-table-column show-overflow-tooltip prop="pm_email" :label="项目经理邮箱" title="项目经理邮箱"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pe_email" :label="工程师邮箱" title="工程师邮箱"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pp_email" :label="计划员邮箱" title="计划员邮箱"></el-table-column> -->

            <el-table-column show-overflow-tooltip prop="remark1" :label="$t('getapi[2394]')" title="项目备注"
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark2" :label="$t('getapi[8144]')" title="计划备注"
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')" title="创建人"
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[135]')" title="创建时间"
                             sortable="custom" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')" title="修改人"
                             sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[1210]')" title="修改时间"
                             sortable="custom" width="120"></el-table-column>
            <!-- <el-table-column show-overflow-tooltip prop="pm_person" :label="项目经理更新人" title="项目经理更新人"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pm_time" :label="PM更新时间" title="PM更新时间"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pe_person" :label="工程师更新人" title="工程师更新人"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pe_time" :label="PE更新时间" title="PE更新时间"></el-table-column>
            <el-table-column show-overflow-tooltip prop="sd_person" :label="供应商开发更新人" title="供应商开发更新人"></el-table-column>
            <el-table-column show-overflow-tooltip prop="sd_time" :label="SD更新时间" title="SD更新时间"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_person" :label="采购更新人" title="采购更新人"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pur_time" :label="Pur更新时间" title="Pur更新时间"></el-table-column>
            <el-table-column show-overflow-tooltip prop="mould_person" :label="工装模具更新人" title="工装模具更新人"></el-table-column>
            <el-table-column show-overflow-tooltip prop="mould_time" :label="Mould更新时间" title="Mould更新时间"></el-table-column>
            <el-table-column show-overflow-tooltip prop="produce_person" :label="制造周期更新人" title="制造周期更新人"></el-table-column>
            <el-table-column show-overflow-tooltip prop="produce_time" :label="制造周期更新时间" title="制造周期更新时间"></el-table-column> -->


            <el-table-column fixed="right" :label="$t('getapi[6048]')" width="90">
                <!-- 编辑删除 -->
                <template slot-scope="scope">
                    <el-button :disabled="!btn.edit" @click.native.prevent="dialog_edit(scope)" type="text" size="mini">
                        {{ $t('getapi[34]') }}
                    </el-button>
                    <el-button :disabled="!btn.edit" @click.native.prevent="dialog_del(scope)" type="text" size="mini">
                        {{ $t('getapi[40]') }}
                    </el-button>
                </template>
            </el-table-column>
            <!-- <el-popconfirm :confirmButtonText="$t('getapi[6109]')" :cancelButtonText="$t('getapi[6]')" icon="el-icon-info" iconColor="red" :title="$t('getapi[637]')" @onConfirm="del(scope)">
                <el-button :disabled="!btn.del" slot="reference" type="text" size="mini">{{ $t('getapi[40]') }}</el-button>
            </el-popconfirm> -->

        </el-table>
        <!-- 表格 -->
        <!-- 分页 -->
        <el-row class="page">
            <el-col :span="12">
                <el-pagination @size-change="handleSizeChange"
                               @current-change="handleCurrentChange" :page-sizes="[50, 100, 200, 300, 400]"
                               :page-size="PageSize" background layout="total, sizes, prev, pager, next, jumper"
                               :total="total">
                </el-pagination>
            </el-col>
            <el-col :span="12">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{DbTbNames}}
                </div>
            </el-col>
        </el-row>
        <!-- 分页 -->
        <!-- 搜索弹框 -->
        <serce :isVisible="isVisible" queryData="ENG_NewProduct" ref="ser" @getser="serclick"></serce>
        <!-- 搜索弹框 -->

        <!-- 编辑弹框 -->
        <el-dialog v-dialogDrag :visible.sync="editvisi" :title="$t('getapi[34]')+'-'+formInline.order_no" width="900px"
                   :close-on-click-modal="false">
            <el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="68px"
                     label-position="left" size="small">
                <el-form-item :label="$t('getapi[2610]')">
                    <el-input v-model="formInline.csr_id"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[8130]')">
                    <el-input v-model="formInline.csr_orderno"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[1586]')">
                    <el-input v-model="formInline.csr_lineno" type="number" autocomplete="off" title=""
                              @mousewheel.native.prevent></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[2390]')">
                    <el-input v-model="formInline.csr_partcode"></el-input>
                </el-form-item>

                <el-form-item :label="$t('getapi[8131]')">
                    <!-- <el-input placeholder="客户交期" v-model="formInline.csr_deliverydate" type="date"></el-input> -->
                    <el-date-picker type="date" v-model="formInline.csr_deliverydate"
                                    style="width: 100%;"></el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('getapi[8132]')">
                    <!-- <el-input placeholder="订单日期" v-model="formInline.csr_orderdate" type="date"></el-input> -->
                    <el-date-picker type="date" v-model="formInline.csr_orderdate"
                                    style="width: 100%;"></el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('getapi[8133]')">
                    <el-select v-model="formInline.part_flag">
                        <el-option label="" value=""></el-option>
                        <el-option :label="$t('getapi[8134]')" value="简单"></el-option>
                        <el-option :label="$t('getapi[8135]')" value="复杂"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('getapi[8136]')">
                    <!-- <el-input placeholder="预计交期" v-model="formInline.delivery_date" type="date"></el-input> -->
                    <el-date-picker type="date" v-model="formInline.delivery_date"
                                    style="width: 100%;"></el-date-picker>
                </el-form-item>

                <el-form-item :label="$t('getapi[1520]')">
                    <el-input v-model="formInline.leadtime_purchase" type="number" autocomplete="off" title=""
                              @mousewheel.native.prevent></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[8137]')">
                    <el-input v-model="formInline.leadtime_produce" type="number" autocomplete="off" title=""
                              @mousewheel.native.prevent></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[8138]')">
                    <el-input v-model="formInline.leadtime_mold" type="number" autocomplete="off" title=""
                              @mousewheel.native.prevent></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[8139]')">
                    <el-input v-model="formInline.leadtime_total" type="number" autocomplete="off" title=""
                              @mousewheel.native.prevent></el-input>
                </el-form-item>
                <br/>


                <el-form-item :label="$t('getapi[163]')">
                    <el-input v-model="formInline.pp_name"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[8140]')" style="width: 420px;" label-width="140px">
                    <el-input v-model="formInline.pp_email" class="myWidth"></el-input>
                </el-form-item>
                <br/>

                <el-form-item :label="$t('getapi[6410]')">
                    <el-input v-model="formInline.pm_name"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[8141]')" style="width: 420px;" label-width="140px">
                    <el-input v-model="formInline.pm_email" class="myWidth"></el-input>
                </el-form-item>
                <br/>

                <el-form-item :label="$t('getapi[8142]')">
                    <el-input v-model="formInline.pe_name"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[8143]')" style="width: 420px;" label-width="140px">
                    <el-input v-model="formInline.pe_email" class="myWidth"></el-input>
                </el-form-item>


                <!-- <div>
                    <span style="width: 85px;display: inline-block;line-height: 32px;">计划员邮箱</span>
                    <el-input placeholder="计划员邮箱" v-model="formInline.pp_email" style="width: 400px;max-width:400px;"></el-input>
                </div>

                <div>
                    <span style="width: 100px;display: inline-block;line-height: 32px;">项目经理邮箱</span>
                    <el-input placeholder="项目经理邮箱" v-model="formInline.pm_email" style="width: 385px;max-width:400px;"></el-input>
                </div>

                <div>
                    <span style="width: 85px;display: inline-block;line-height: 32px;">工程师邮箱</span>
                    <el-input placeholder="工程师邮箱" v-model="formInline.pe_email" style="width: 400px;max-width:400px;"></el-input>
                </div>
                -->
                <br/>
                <el-form-item :label="$t('getapi[2394]')">
                    <el-input v-model="formInline.remark1"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[8144]')">
                    <el-input v-model="formInline.remark2"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[2095]')">
                    <el-input v-model="formInline.order_no" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[1861]')">
                    <el-input v-model="formInline.order_status" :disabled="true"></el-input>
                </el-form-item>
                <br/>
                <el-form-item :label="$t('getapi[3099]')">
                    <el-input v-model="formInline.create_person" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[135]')">
                    <el-input v-model="formInline.create_time" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[733]')">
                    <el-input v-model="formInline.modify_person" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('getapi[1210]')">
                    <el-input v-model="formInline.modify_time" :disabled="true"></el-input>
                </el-form-item>
                <br/>
                <span style="padding: 9px;">{{$t('getapi[8145]')}}</span>

            </el-form>

            <span slot="footer" class="dialog-footer">
				<el-button @click="dialog_cancel">{{ $t('getapi[6]') }}</el-button>
				<el-button v-if="editShowSave" @click="dialog_sava" :loading="loading" :disabled="loading"
                           type="primary">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>
        <!-- 编辑弹框 -->
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import urlpost from '@/api/config.js';

    export default {
        name: 'npplan',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-180
            }
        },
        data() {
            return {
                formInline: {
                    order_no: null,
                    order_status: null,
                    sort_id: null,
                    csr_orderno: null,
                    csr_lineno: null,
                    csr_partcode: null,
                    csr_qty: null,
                    csr_id: null,
                    csr_deliverydate: null,
                    csr_orderdate: null,
                    csr_name: null,
                    pm_name: null,
                    pe_name: null,
                    pp_name: null,
                    pm_email: null,
                    pe_email: null,
                    pp_email: null,
                    part_flag: null,
                    leadtime_total: null,
                    leadtime_purchase: null,
                    leadtime_mold: null,
                    leadtime_produce: null,
                    sales_flag: null,
                    delivery_date: null,
                    remark1: null,
                    remark2: null,
                    create_person: null,
                    create_time: null,
                    modify_person: null,
                    modify_time: null,
                    pm_person: null,
                    pm_time: null,
                    pe_person: null,
                    pe_time: null,
                    sd_person: null,
                    sd_time: null,
                    pur_person: null,
                    pur_time: null,
                    mould_person: null,
                    mould_time: null,
                    produce_person: null,
                    produce_time: null,
                },
                formLineScope: null,

                dataSet: [],	//表格-数据
                DbTbNames: '', //表格-表名
                PageIndex: 1,	//表格-页标
                PageSize: this.$http.getPageSize('npplan'),	//表格-页大小
                SelectIndex: 0,	//表格-页标
                total: 0, // 表格-数据总量
                loading: false, // 表格-加载状态
                selectData: [], // 多选数组
                isVisible: false,// 搜索弹框
                queryData: [], // 查询数组
                editvisi: false,	//编辑对话框-是否显示
                editShowSave: false,		//编辑对话框-保存按钮
                btn: {
                    del: false,
                    edit: false
                }
            };
        },
        create() {
        },
        beforeMount() {
            // console.log('----beforeMount---');
            // let that = this;
            // that.getqwlist();
            // urlpost.urlpost('Basic/GetShopGroupList', {}, function (res) {
            // 	console.log(res);
            // 	if (res.Success) {
            // 		that.ShopGroupList = res.DataContent;
            // 	}
            // });
            // urlpost.urlpost('Basic/WH/GetCalendarDropDown', {}, function (res) {
            // 	console.log(res);
            // 	if (res.Success) {
            // 		that.CalendarDropDown = res.DataContent;
            // 	}
            // });
        },
        mounted() {
            let that = this;
            that.getView();
            that.authority();
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
        },
        methods: {
            authority() {
                //按钮操作权限
                let that = this;

                if (that.selectData.length > 0) {
                    that.$refs.SetBtn.SetButtonEnable('import,search,refresh,export,del');
                }
                else {
                    that.$refs.SetBtn.SetButtonEnable('import,search,refresh,export');
                }
                that.btn.edit = true;
                that.btn.del = true;
                // //只读权
                // if (that.$limits.ReadOnlyRights('plv2', 26, 1)) {
                // 	that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                // }
                // //操作权
                // let ilimits = that.$limits.UnOperationAuthority('plv2', 26, 1);
                // // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
                // switch (ilimits) {
                // 	case 2:
                // 		that.btn.edit = true;
                // 		that.btn.del = false;
                // 		that.$refs.SetBtn.SetButtonEnable('create,search,save,refresh,export');
                // 		break;
                // 	case 3:
                // 		that.btn.edit = true;
                // 		that.btn.del = true;
                // 		that.$refs.SetBtn.SetButtonEnable('create,search,save,del,refresh,export');
                // 		break;
                // 	default:
                // 		that.$refs.SetBtn.SetButtonEnable('');
                // 		break;
                // }
            },
            search() {
                // 查询
                this.isVisible = true;
                this.$refs.ser.clearInput(this.isVisible, 'ENG_NewProduct');
            },
            serclick(val) {
                // 查询对话框
                let that = this;
                that.queryData = val;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            handleSizeChange(val) {
                //修改页数
                this.PageSize = val;
                this.$http.savePageSize('npplan',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                //跳页
                this.PageIndex = val;
                this.getView();
                this.authority();
            },
            handleSelectionChange(val) {
                // 选择行
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                console.log('-------', val);
                that.authority();
            },
            reflash() {
                // 刷新
                this.getView();
            },
            getView() {
                // 获取数据
                let that = this;
                that.loading = true;
                this.isVisible = false;

                let data = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                for (let i = 0; i < that.queryData.length; i++) {
                    if (!that.queryData[i].query_sort && !that.queryData[i].query_Condition) {
                        continue;
                    }
                    data.Param.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                that.$http.urlpost('/Eng/NewProduct/Plan/DataList', data, function (res) {
                    that.loading = false;
                    if (res.Success) {
                        that.dataSet = res.DataContent
                        that.total = res.Totals
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.$nextTick(function(){
                        that.$processdata.initForm(that.SelectIndex)
                    });
                    that.authority();
                });
            },
            exp() {
                //导出
                let that = this;
                that.loading = true;
                let data = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                for (let i = 0; i < that.queryData.length; i++) {
                    data.Param.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].query_field_type,
                        query_field_name: that.queryData[i].query_field_name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                that.$http.urlpost('/Eng/NewProduct/Plan/ToExecl', data, function (res) {
                    that.loading = false;
                    if (res.Success) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            imp() {
                // 导入
                let item = {
                    label: '通用导入',
                    name: 'exp',
                    path: '/exp/40',
                    url: '/exp/40',
                    icon: 'video-play'
                };
                this.$router.push({path: '/exp/40'});
                this.$store.commit('selectMenu', item);
            },

            add() {
                // 对话框-新增 记录
                let r1 = this.formInline;
                for (var key in r1) {
                    r1[key] = null;
                }
                this.editvisi = true;
            },
            cellDBClick(row, column, cell, event) {
                // 编辑
                // console.log('-------cellDBClick---------',row, column, cell, event);
                let that = this;
                that.authority();
            },
            dialog_show(jsd) {
                this.formLineScope = jsd;
                this.formInline = JSON.parse(JSON.stringify(jsd.row));
                this.editvisi = true;
                this.editShowSave = false;

            },
            dialog_sava() {
                // 保存数据
                let that = this;
                let parm = [that.formInline];
                that.$http.urlpost('/Eng/NewProduct/Plan/Save', parm, function (res) {
                    that.loading = false;
                    if (res.Success) {
                        that.$message.success(that.$t('getapi[284]'));
                        that.editvisi = false;
                        if (that.formLineScope) {
                            that.dataSet.splice(that.formLineScope.$index, 1, res.DataContent[0]);
                        }
                    }
                    else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            dialog_edit(jsd) {
                // 编辑对话框
                this.dialog_show(jsd);
                this.editShowSave = true;
            },
            dialog_cancel() {
                this.formLineScope = null;
                this.editvisi = false;
            },
            delall() {
                //批量选择的记录
                let that = this;
                if (!that.selectData) {
                    return;
                }
                if (that.selectData.length == 0) {
                    return;
                }
                // selectData 未存储index, index: that.selectData.$index
                let rows = [];
                for (var i = 0; i < that.selectData.length; i++) {
                    rows.push({order_no: that.selectData[i].order_no, modify_time: that.selectData[i].modify_time});
                }
                //
                this.delete_rows(rows, function () {
                    that.selectData = [];
                    that.reflash();
                    // // 批量删除后移除记录
                    // that.selectData = [];
                    // that.$refs.multipleTable.clearSelection();
                    // rows.sort(function (a, b) {
                    // 	return b.index - a.index;
                    // }).forEach(function (e) {
                    // 	console.log('----------', e.index);
                    // 	that.dataSet.splice(e.index, 1);
                    // 	return;
                    // });
                });
            },

            dialog_del(jsd) {
                // 对话框删除数
                if (!jsd) {
                    return;
                }
                let row = jsd.row;
                if (!row) {
                    return;
                }
                let that = this;
                let rows = [];
                rows.push({order_no: row.order_no, modify_time: row.modify_time});
                this.delete_rows(rows, function () {
                    that.dataSet.splice(jsd.$index, 1);
                });
            },
            delete_rows(rows, callback) {
                let that = this;
                if (!rows) {
                    return;
                }
                if (rows.length == 0) {
                    return;
                }
                let parm = [];
                for (var i = 0; i < rows.length; i++) {
                    parm.push({order_no: rows[i].order_no, modify_time: rows[i].modify_time});
                }
                let msg = that.$t('getapi[8594]')//'此操作将永久删除该数据, 是否继续?';
                if (parm.length == 1) {
                    msg = msg + '</p>' + parm[0].order_no;
                }
                else {
                    msg = msg + '</p>已选择的' + parm.length + '笔记录';
                }
                this.$confirm(msg, that.$t('getapi[194]'), {
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning',
                    dangerouslyUseHTMLString: true
                }).then(() => {
                    that.$http.urlpost('/Eng/NewProduct/Plan/Delete', parm, function (res) {
                        if (res.Success) {
                            callback();
                        }
                        else {
                            that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                        }
                    });
                }).catch(() => {
                    // this.$message({
                    //   type: 'info',
                    //   message: '已取消删除'
                    // });
                });
            },

            // mydatetostring(val) {
            // 	if (!val) {
            // 		return val;
            // 	}
            // 	if (val.length < 10) {
            // 		return val;
            // 	}
            // 	return val.substr(0, 10);
            // },
            // fmtdatetime(val) {
            // 	if (!val) {
            // 		return val;
            // 	}
            // 	if (val.length == 12) {
            // 		return val + ' 00:00:00';
            // 	}
            // 	else {
            // 		return val;
            // 	}
            // },
            myformatter(row, column, cellValue, index) {
                // if (index == 0) {
                // 	console.log('----', row, column, cellValue);
                // }
                if (!cellValue) {
                    return cellValue;
                }
                if (cellValue.length < 10) {
                    return cellValue;
                }
                return cellValue.substr(0, 10);
            },
            sortChange(column) {
                let that = this
                let name = column.prop
                console.log(column)
                if (column.order == "ascending") {
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return -1;
                        } else if (val1 > val2) {
                            return 1;
                        } else {
                            return that.dataSet.indexOf(obj1) - that.dataSet.indexOf(obj2);
                        }
                    }
                    that.dataSet = that.dataSet.sort(compare);
                } else if (column.order == "descending") {
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return 1;
                        } else if (val1 > val2) {
                            return -1;
                        } else {
                            return that.dataSet.indexOf(obj2) - that.dataSet.indexOf(obj1);
                        }
                    }
                    that.dataSet = that.dataSet.sort(compare);
                }
            },
        }
    };
</script>

<style scoped lang="less">
    .myWidth {
        width: 380px;
    }

    .el-form-item {
        margin-top: 1px;
        margin-bottom: 1px;
        margin-left: 9px;
    }

    /deep/ .el-form-item__label {
        padding-right: 6px;
    }

    /deep/ .el-form-item__content {
        width: 125px;
    }

    /deep/ .el-form-item__content input.el-input__inner {
        max-width: 370px;
    }
</style>